import { IoIosArrowForward, IoIosArrowDown, IoIosWarning } from 'react-icons/io';
import { IoCheckmark } from 'react-icons/io5';
import { toSpecialFixed } from '@/lib/misc/utils';
import { useIsMobile } from '@/hooks/utilities/use-mobile';
import { useState } from 'react';
import getFeesFromQuote from '@/lib/trade/getFeesFromQuote';
import { ChainId, ZERO_ADDRESS } from '@shared/utils/config/networks';
import { useSwap } from '@/contexts/SwapProvider';
import { validate } from '../swap-home/const';
export default function SwapQuoteData({
  quoteStringInfo,
  priceFetching,
  quoteFetching,
  quoteLoad,
  setInfoType,
  setIsModalOpen,
  quoteData
}) {
  const [showFees, setShowFees] = useState(false);
  const {
    geniusFees,
    gasFees,
    netSponsorFees,
    sponsorFees,
    bridgeFees,
    netNativeSponsorAmount,
    network,
    nativeCurrency,
    aggregator,
    networkOut
  } = getFeesFromQuote({
    quoteData
  });
  const isMobile = useIsMobile();
  function handleShowInfo(name) {
    setInfoType(name);
    setIsModalOpen(true);
  }
  const {
    fromAssets,
    toAssets
  } = useSwap();
  const inputNetworks = fromAssets?.map(x => x.network);
  const outputNetworks = toAssets?.map(x => x.network);
  const uniqueNetworks = [...inputNetworks, ...outputNetworks].filter((x, i, a) => a.indexOf(x) === i);
  const totalFee = () => {
    let fees = 0;
    if (geniusFees && !isNaN(geniusFees)) {
      fees += geniusFees;
    }
    if (gasFees && !isNaN(gasFees)) {
      fees += gasFees;
    }
    if (bridgeFees && !isNaN(bridgeFees)) {
      fees += bridgeFees;
    }
    return fees;
  };
  return quoteStringInfo?.message ? <div className='break-all px-8 md:px-6 flex items-center justify-center flex-wrap text-sm w-full pt-12 ' data-sentry-component="SwapQuoteData" data-sentry-source-file="SwapQuoteData.tsx"></div> : quoteStringInfo?.length && !priceFetching && !quoteFetching && !quoteLoad && <div className={`flex flex-col px-8 md:px-6 text-sm z-50 font-light space-y-2 ${isMobile ? 'mt-4' : 'mb-2'}`}>
        <div className='w-full justify-between flex text-genius-cream'>
          <div className='text-genius-cream/50'>Simulations</div>
          <div className='flex items-center'>
            Passed
            <span className='text-green-300'>
              <IoCheckmark className='w-[12px] ml-2' />
            </span>
          </div>
        </div>

        <div onClick={() => {
      setShowFees(!showFees);
      setIsModalOpen(false);
    }} className='w-full justify-between flex text-genius-cream'>
          <div className='flex items-center justify-start text-genius-cream/50'>Total Fee</div>
          <div>
            <p className='flex items-center'>
              ${toSpecialFixed(totalFee())?.value}
              {showFees ? <IoIosArrowDown className='w-[12px] h-[12px] ml-1' /> : <IoIosArrowForward className='w-[12px] h-[12px] ml-1' />}
            </p>
          </div>
        </div>
        {showFees && <div className='pl-4 text-genius-cream'>
            <div className='w-full justify-between flex space-y-1 '>
              <div className='flex items-center justify-end w-[90px] text-genius-cream/50 underline cursor-pointer' onClick={() => handleShowInfo('genius')}>
                Genius Fee
              </div>
              <div>
                <p className='flex items-center'>${toSpecialFixed(geniusFees)?.value}</p>
              </div>
            </div>

            {gasFees && !isNaN(gasFees) ? <div className='w-full justify-between flex space-y-1 text-genius-cream'>
                <div className='flex items-center justify-end w-[90px] text-genius-cream/50 underline cursor-pointer' onClick={() => handleShowInfo('gas')}>
                  Gas Fee
                </div>

                <div className='flex flex-col justify-end items-end'>
                  <p className='flex items-center'>${toSpecialFixed(gasFees)?.value}</p>
                  <>
                    {' '}
                    {!sponsorFees || parseFloat(network) != ChainId.SOLANA && !bridgeFees ? <p className='text-[10px] text-genius-cream/50'>
                        using your native balance
                        {bridgeFees && ' and token order'}
                      </p> : <p className='text-[10px] text-genius-cream/50'>using your token order</p>}
                  </>
                </div>
              </div> : <></>}

            {bridgeFees && !isNaN(bridgeFees) ? <div className='w-full justify-between flex space-y-1 text-genius-cream'>
                <div className='flex items-center justify-end w-[90px] text-genius-cream/50 underline cursor-pointer' onClick={() => handleShowInfo('dln')}>
                  Bridge Fee
                </div>
                <div>
                  <p className='flex items-end justify-end '>
                    ${toSpecialFixed(bridgeFees)?.value}
                  </p>

                  <>
                    {' '}
                    {!sponsorFees || parseFloat(network) != ChainId.SOLANA && !bridgeFees ? <p className='text-[10px] text-genius-cream/50'>
                        using your native balance
                        {bridgeFees && ' and token order'}
                      </p> : <p className='text-[10px] text-genius-cream/50'>using your token order</p>}
                  </>
                </div>
              </div> : <></>}
          </div>}

        {quoteStringInfo?.map((quoteItem, index) => {
      if (quoteItem?.address == '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee' || quoteItem?.address == ZERO_ADDRESS) {
        if (parseFloat(networkOut) == ChainId.AVALANCHE) {
          quoteItem.symbol = 'AVAX';
        } else if (parseFloat(networkOut) == ChainId.POLYGON) {
          quoteItem.symbol = 'MATIC';
        } else if (parseFloat(networkOut) == ChainId.BSC) {
          quoteItem.symbol = 'BNB';
        } else {
          quoteItem.symbol = 'ETH';
        }
      }
      return <div key={index} className='w-full justify-between flex items-start text-genius-cream'>
              <p className='text-sm flex items-end text-genius-cream/50'>
                Amount {quoteItem?.symbol}
              </p>
              <div className='text-sm gap-2 ta-r'>
                <p className='flex items-center text-green-400'>
                  {toSpecialFixed(quoteItem?.formattedAmount, 3)?.value}
                  <div className='ml-1'> (${toSpecialFixed(quoteItem?.usdValue, 2)?.value})</div>
                </p>
                <p className='text-[10px] text-genius-cream/50'>via {aggregator}</p>
              </div>
            </div>;
    })}
        {netSponsorFees && !isNaN(netSponsorFees) ? <div className='w-full justify-between flex space-y-1 text-genius-cream'>
            <div className='flex items-center justify-end text-genius-cream/50  cursor-pointer ' onClick={() => handleShowInfo('sponsor')}>
              Amount {nativeCurrency}
            </div>
            <div className='flex justify-end flex-col items-end'>
              <p className='flex items-center text-green-400'>
                <p className='flex items-center'>
                  {toSpecialFixed(netNativeSponsorAmount, 3)?.value}
                  <div className='ml-1'> (${netSponsorFees.toFixed(2)})</div>
                </p>
              </p>
              <p className='text-[10px] text-genius-cream/50 '>via Genius Sponsorship</p>
            </div>
          </div> : <></>}

        {validate(fromAssets, toAssets)?.customError ? <>
            <div className='flex flex-col  text-md mt-5'>
              <div className=' p-2 text-left text-xs text-genius-cream bg-yellow-500 bg-opacity-10 border-yellow-400 border-[1px] rounded-lg my-4'>
                {validate(fromAssets, toAssets)?.customError}
              </div>
            </div>
          </> : <></>}

        {inputNetworks?.includes(ChainId.ETHEREUM) || outputNetworks?.includes(ChainId.ETHEREUM) ? <div className='flex flex-col  text-md mt-5'>
            <div className=' p-2 text-left text-xs text-genius-cream bg-yellow-500 bg-opacity-10 border-yellow-400 border-[1px] rounded-lg my-4'>
              You are making a trade involving Ethereum Mainnet where gas prices are expensive.
              Please make sure you comfortable with the amount paid in fees for this order.
            </div>
          </div> : <></>}

        {isMobile && <>
            <div className='text-genius-cream text-left text-[14px]'>Disclosure</div>
            <div className='text-genius-cream/60 text-left text-[14px]'>
              Trade may execute at different prices than stated.
            </div>
          </>}
      </div>;
}